import React, { Component } from "react"
import { connect } from "react-redux"
import caInfoCircle from "../../assets/images/ca_info_circle_black.svg"
import searchIcon from "../../assets/images/search_icon.svg"
import { Button, Loader } from "semantic-ui-react"
import placeholderCar from "../../assets/images/car.svg"
import { navigateTo } from "../../helpers/navigationHelpers"
import { isEmpty } from "lodash"
import { gaJSON, trackFirebaseAnalytics } from "../../helpers/googleAnalyticsHelpers"

class SelectVehicle extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      searchQuery: ""
    }
    this.navigateTo = navigateTo.bind(this)
  }

  componentDidMount() {
    this.props.dispatch({
      type: "VEHICLES_LOAD_SAGA",
      payload: {}
    })
  }

  componentDidUpdate(prevProps) {
    // When vehicles are loaded, set loading to false
    if (this.state.loading && prevProps.vehicles !== this.props.vehicles) {
      this.setState({ loading: false })
    }
  }

  handleSearchChange = (e) => {
    this.setState({ searchQuery: e.target.value })
  }

  setVehicle = (vehicle, user) => {
    trackFirebaseAnalytics({
      event: gaJSON.select_vehicle_clicked,
      params: {
        vehicle_id: vehicle.id,
        user_role: user.roles.toString()
      }
    })

    this.props.dispatch({ type: "TIRES_SET_VEHICLE", payload: { vehicle } })
    this.navigateTo("tireSize")
  }

  renderVehicleCards() {
    const { vehicles } = this.props
    const { searchQuery } = this.state
    const { user } = this.props
    const searchTerm = searchQuery.trim().toLowerCase()
    const filteredVehicles = (vehicles || []).filter((vehicle) => {
      const term = searchTerm?.toLowerCase() || ""
      const fleetcorEnrolled = vehicle?.fleetcor_enrolled || false
      return (
        vehicle.is_active === true &&
        fleetcorEnrolled &&
        (String(vehicle?.year).includes(term) ||
          vehicle?.make?.toLowerCase().includes(term) ||
          vehicle?.model?.toLowerCase().includes(term) ||
          vehicle.vin?.toLowerCase().includes(term) ||
          String(vehicle.other_id || "")
            .toLowerCase()
            .includes(term) ||
          vehicle.license_plate_number?.toLowerCase().includes(term) ||
          String(vehicle.department_number || "")
            .toLowerCase()
            .includes(term))
      )
    })

    if (isEmpty(filteredVehicles)) {
      return (
        <div className="h-full text-center">
          <p style={{ marginTop: "25px" }}>
            No matching vehicles found. To shop for tires, you need at least one eligible vehicle.
            You can add a vehicle on the Vehicles page.
          </p>
        </div>
      )
    }

    return (filteredVehicles || []).map((vehicle, idx) => (
      <div className="vehicle-card" key={idx}>
        <div className="vehicle-card-content">
          <div className="vehicle-info">
            <div className="vehicle-name-image">
              <div>
                <h2 className="vehicle-title">{vehicle.name || "N/A"}</h2>
                <p className="vehicle-vin">VIN: {vehicle.vin || "N/A"}</p>
              </div>
              <div className="vehicle-image">
                <img src={vehicle.dashboard_url || placeholderCar} alt={vehicle.name || "N/A"} />
              </div>
            </div>
            <div className="vehicle-details">
              <div>
                <span className="label">Plate:</span> {vehicle.license_plate_number || "N/A"}
              </div>
              <div>
                <span className="label">Other ID:</span> {vehicle.other_id || "N/A"}
              </div>
              <div>
                <span className="label">Mileage:</span> {vehicle.miles || "N/A"}
              </div>
              <div>
                <span className="label">Dept. No.:</span> {vehicle.department_number || "N/A"}
              </div>
            </div>
          </div>
        </div>
        <Button
          className="select-button default-btn"
          onClick={() => this.setVehicle(vehicle, user)}
        >
          Select vehicle
        </Button>
      </div>
    ))
  }

  render() {
    const { loading } = this.state
    const { step } = this.props

    return (
      <div className="select-vehicle-container">
        <h2 className="text-lg font-semibold mb-4 text-center tires-step-header">
          Step {step.step} / 6: Select Vehicle
        </h2>
        <div className="ineligibility-banner">
          <img className="ca-info-circle" src={caInfoCircle} />
          <p>
            <b>
              Only class one and two vehicles under 10,000lbs are available for online ordering.
            </b>{" "}
            For other vehicles or vehicles requiring specialty tires, check with your local shop and
            book a maintenance appointment with 'New Tires' selected.
          </p>
        </div>
        <div className="search-bar">
          <img src={searchIcon} className="search-icon" />
          <input
            type="text"
            className="search-input"
            placeholder="Search vehicle by VIN, ID..."
            value={this.state.searchQuery}
            onChange={this.handleSearchChange}
          />
        </div>
        <div className="vehicle-cards-list">
          {loading ? (
            <div style={{ textAlign: "center", marginTop: "40px" }}>
              <Loader active inline="centered" size="large" />
            </div>
          ) : (
            this.renderVehicleCards()
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  vehicles: state.vehicles.vehicles,
  user: state.application.userSessionData || (state.users && state.users.currentUser)
})

export default connect(mapStateToProps)(SelectVehicle)
